var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 367,
    viewBox: "0 0 390 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 375.978,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 375.978 268.004)",
    fill: "url(#paint0_linear_16_49)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 352.84,
    r: 13.4966,
    transform: "rotate(-180 285.358 352.84)",
    fill: "url(#paint1_linear_16_49)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 285.358 268.004)",
    fill: "url(#paint2_linear_16_49)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 352.84,
    r: 13.4966,
    transform: "rotate(-180 194.737 352.84)",
    fill: "url(#paint3_linear_16_49)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 194.737 268.004)",
    fill: "url(#paint4_linear_16_49)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 352.84,
    r: 13.4966,
    transform: "rotate(-180 104.117 352.84)",
    fill: "url(#paint5_linear_16_49)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 104.117 268.004)",
    fill: "url(#paint6_linear_16_49)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.978,
    cy: 183.169,
    r: 13.4966,
    transform: "rotate(-180 375.978 183.169)",
    fill: "url(#paint7_linear_16_49)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.978,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 375.978 98.332)",
    fill: "url(#paint8_linear_16_49)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 183.169,
    r: 13.4966,
    transform: "rotate(-180 285.358 183.169)",
    fill: "url(#paint9_linear_16_49)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 285.358 98.332)",
    fill: "url(#paint10_linear_16_49)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 183.168,
    r: 13.4966,
    transform: "rotate(-180 194.737 183.168)",
    fill: "url(#paint11_linear_16_49)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 194.737 98.332)",
    fill: "url(#paint12_linear_16_49)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 183.168,
    r: 13.4966,
    transform: "rotate(-180 104.117 183.168)",
    fill: "url(#paint13_linear_16_49)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 104.117 98.332)",
    fill: "url(#paint14_linear_16_49)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4963,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 13.4963 268.004)",
    fill: "url(#paint15_linear_16_49)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4963,
    cy: 183.168,
    r: 13.4966,
    transform: "rotate(-180 13.4963 183.168)",
    fill: "url(#paint16_linear_16_49)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4963,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 13.4963 98.332)",
    fill: "url(#paint17_linear_16_49)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 13.497,
    r: 13.4966,
    transform: "rotate(-180 285.358 13.497)",
    fill: "url(#paint18_linear_16_49)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 13.497,
    r: 13.4966,
    transform: "rotate(-180 194.737 13.497)",
    fill: "url(#paint19_linear_16_49)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 13.497,
    r: 13.4966,
    transform: "rotate(-180 104.117 13.497)",
    fill: "url(#paint20_linear_16_49)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_49",
    x1: 362.202,
    y1: 252.101,
    x2: 385.696,
    y2: 279.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_49",
    x1: 271.582,
    y1: 336.937,
    x2: 295.076,
    y2: 364.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_49",
    x1: 271.582,
    y1: 252.101,
    x2: 295.076,
    y2: 279.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_49",
    x1: 180.962,
    y1: 336.937,
    x2: 204.455,
    y2: 364.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_49",
    x1: 180.962,
    y1: 252.101,
    x2: 204.455,
    y2: 279.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_49",
    x1: 90.3411,
    y1: 336.937,
    x2: 113.835,
    y2: 364.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_49",
    x1: 90.3411,
    y1: 252.101,
    x2: 113.835,
    y2: 279.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16_49",
    x1: 362.202,
    y1: 167.266,
    x2: 385.696,
    y2: 195.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16_49",
    x1: 362.202,
    y1: 82.4286,
    x2: 385.696,
    y2: 110.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16_49",
    x1: 271.582,
    y1: 167.266,
    x2: 295.076,
    y2: 195.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16_49",
    x1: 271.582,
    y1: 82.4286,
    x2: 295.076,
    y2: 110.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16_49",
    x1: 180.962,
    y1: 167.265,
    x2: 204.455,
    y2: 195.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16_49",
    x1: 180.962,
    y1: 82.4286,
    x2: 204.455,
    y2: 110.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_16_49",
    x1: 90.3411,
    y1: 167.265,
    x2: 113.835,
    y2: 195.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_16_49",
    x1: 90.3411,
    y1: 82.4286,
    x2: 113.835,
    y2: 110.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_16_49",
    x1: -0.279291,
    y1: 252.101,
    x2: 23.2145,
    y2: 279.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_16_49",
    x1: -0.279291,
    y1: 167.265,
    x2: 23.2145,
    y2: 195.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_16_49",
    x1: -0.279291,
    y1: 82.4286,
    x2: 23.2145,
    y2: 110.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_16_49",
    x1: 271.582,
    y1: -2.40633,
    x2: 295.076,
    y2: 25.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_16_49",
    x1: 180.962,
    y1: -2.40633,
    x2: 204.455,
    y2: 25.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_16_49",
    x1: 90.3411,
    y1: -2.40633,
    x2: 113.835,
    y2: 25.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E99C3",
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsDark);
export default __webpack_public_path__ + "static/media/dots-dark.1fc6986173847c279ae4e7010c419bfb.svg";
export { ForwardRef as ReactComponent };